import { UserManagerSettings, WebStorageStateStore } from "oidc-client-ts";
import * as msal from "@azure/msal-browser";

export const authSettings = {
    authority: process.env.REACT_APP_AUTHORITY_URL,
    client_id: process.env.REACT_APP_CLIENT_ID,
    redirect_uri: `${window.location.protocol}//${window.location.hostname}${window.location.port ? `:${window.location.port}` : ''}/signin-callback`,
    silent_redirect_uri: `${window.location.protocol}//${window.location.hostname}${window.location.port ? `:${window.location.port}` : ''}/silent-callback`,
    automaticSilentRenew: true,
    post_logout_redirect_uri: `${window.location.protocol}//${window.location.hostname}${window.location.port ? `:${window.location.port}` : ''}`,
    response_type: "code",
    scope: "openid profile offline_access Revelation.Api",
    validateSubOnSilentRenew: false,
    includeIdTokenInSilentRenew: true,
    silentRequestTimeoutInSeconds: 5,
    stateStore: new WebStorageStateStore({ store: window.localStorage }), //sessionStore doesn't work in iOS WebView.
} as UserManagerSettings;


export const cookieTenantId = document.cookie.split(";").find(cookie => cookie.trim().startsWith("revTenantId="))?.split("=")[1];

// MSAL.js configuration
let msalConfig = {
    auth: {
        authority: cookieTenantId ? authSettings.authority.replace("/common", `/${cookieTenantId}`) : authSettings.authority,
        clientId: authSettings.client_id,
        redirectUri: window.location.origin + "/silent-end",     // This should be in the list of redirect uris for the AAD app
        navigateToLoginRequestUrl: false,
    },
    cache: {
        cacheLocation: "localStorage",
    }
};

export const msalInstance = new msal.PublicClientApplication(msalConfig);